import { z } from 'zod/v4';
import { SystemEndReason } from '../../cases/index.js';
import { ToolCategory, ToolName, ToolPolicy, ToolWeight } from '../types.js';
export const AGENT_ALLOWED_END_REASONS = [
    SystemEndReason.ErrorUs,
    SystemEndReason.Withdrawn,
    SystemEndReason.ErrorCreditor,
    SystemEndReason.Dead,
    SystemEndReason.Bankruptcy,
    SystemEndReason.Objection,
    SystemEndReason.Expiration,
    SystemEndReason.Irrecoverable,
    SystemEndReason.ForcedDissolved,
    SystemEndReason.Other,
];
const inputSchema = z.object({
    reason: z
        .enum(AGENT_ALLOWED_END_REASONS)
        .describe([
        'Why the case is being ended.',
        'ERROR_US: bookkeeping fix — we created or kept this case in error.',
        'WITHDRAWN: the creditor has withdrawn the case.',
        'ERROR_CREDITOR: bookkeeping fix — the creditor submitted this case in error.',
        'DEAD: the debtor is deceased (verify via get_customer.status.isDeceased before proposing).',
        'BANKRUPTCY: the debtor is in bankruptcy proceedings.',
        'OBJECTION: the debtor has formally objected to the claim and we can no longer pursue.',
        'EXPIRATION: the debt has passed its legal limitations period.',
        'IRRECOVERABLE: no reasonable path to collection remains.',
        'FORCED_DISSOLVED: the debtor company has been forcibly dissolved.',
        'OTHER: use sparingly. If the situation does not match any specific reason, consider whether the case really should be ended at all — escalate_to_human is often the right move instead.',
    ].join(' ')),
    reasoning: z
        .string()
        .max(500)
        .optional()
        .describe('Why you are proposing to end this case. Short rationale visible to the caseworker reviewing the proposal.'),
});
const outputSchema = z.object({
    caseId: z.uuid(),
});
export const endCaseTool = {
    name: ToolName.EndCase,
    category: ToolCategory.CaseManagement,
    weight: ToolWeight.Heavy,
    version: 1,
    defaultPolicy: ToolPolicy.RequireApproval,
    llmDescription: 'Propose ending this case. HEAVY: calling this ends the run; a caseworker reviews and may edit before approving. Ending a case is more drastic than create_update or create_payment_plan — those can be cancelled or rolled back, but a closed case is effectively terminal. Only propose when you have strong evidence from case content (interactions, documents, debtor status) that the case truly should be closed. Most ambiguous situations are better handled by create_update or escalate_to_human.',
    inputSchema,
    outputSchema,
    summarizeProposal: (input) => `End case (reason: ${input.reason})`,
};
//# sourceMappingURL=end-case.js.map